import { __assign } from "tslib";
import { createFakeGetResponder, createFakePostResponder, createFakePutResponder, createFakeDeleteResponder, } from '../../test-utils';
import { createHttpTestKit } from '../../http/test-kit';
import { createAutoRoutingApi } from '.';
export var createAutoRoutingApiTestkit = function () {
    var fakeHttp = createHttpTestKit();
    var api = createAutoRoutingApi('', fakeHttp);
    var autoRoutingRelativePath = '/autoRouting';
    var autoRoutingUriUrl = function (id) { return "".concat(autoRoutingRelativePath, "/groups/").concat(id); };
    var testKit = {
        whenGetAutoRoutingSettings: function () {
            return createFakeGetResponder(fakeHttp, autoRoutingRelativePath);
        },
        whenEnableAutoRoutingFeature: function (dto) {
            return createFakePostResponder(fakeHttp, "".concat(autoRoutingRelativePath, "/feature/enable"))(dto);
        },
        whenDisableAutoRoutingFeature: function (dto) {
            return createFakePostResponder(fakeHttp, "".concat(autoRoutingRelativePath, "/feature/disable"))(dto);
        },
        whenSetAutoRoutingFeatureWorkload: function (dto) {
            return createFakePutResponder(fakeHttp, "".concat(autoRoutingRelativePath, "/workload"))(dto);
        },
        whenSetAutoRoutingFeatureAcceptTime: function (dto) {
            return createFakePutResponder(fakeHttp, "".concat(autoRoutingRelativePath, "/acceptTime"))(dto);
        },
        whenAddAutoRoutingGroup: function (dto) {
            return createFakePostResponder(fakeHttp, autoRoutingUriUrl(dto.groupId))(dto);
        },
        whenremoveAutoRoutingGroup: function (dto) {
            return createFakeDeleteResponder(fakeHttp, autoRoutingUriUrl(dto.groupId));
        },
        whenSetAutoRoutingGroup: function (dto) {
            return createFakePutResponder(fakeHttp, "".concat(autoRoutingRelativePath, "/groups"))(dto);
        },
    };
    return __assign(__assign({}, api), testKit);
};
//# sourceMappingURL=testkit.js.map